import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/aplication';

// APP
function conexionApp(state, action) {
  state.loadTrasversalServices= action.payload.connection ? action.payload.connection:false;
}

function errorApp(state, action) {
  state.error= action.payload.error ? action.payload.error:false;
  state.message= action.payload.message ? action.payload.message:"";
}


/**
 * Conexión
 */
const appReducer = createSlice({
  name: 'app',
  initialState: initState,
  reducers: {
    conexionApp,
    errorApp
  },
});

export const appActions = {
  ...appReducer.actions,
};

export default appReducer.reducer;
